export default {
  UNAUTHORIZED: 401,
  ACCESS_DENIED: 403
};
